import { useAppRouter } from '@/common/route/useAppRouter';
import { timeUnits } from '@/common/utils/helpers';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_DUPLICATE } from '@/modules/duplicate/router';
import { useGameMatchList } from '@/modules/game/match/model/list';
import { duplicateService } from '@/services/duplicate';
import { useVuelidate } from '@vuelidate/core';
import { integer, minValue, required } from '@vuelidate/validators';
import { onMounted, reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useDuplicateItemEdit() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const { fetchAllMatches, gameMatchOptions } = useGameMatchList();

    const model = reactive({
        id: route.params.id,
        name: null,
        type: 0,
        matchId: null,
        cost: 0,
        prizes: '',
        round: 0,
        game: 1,
        timeUnit: 0,
        timeDuration: 0,
        prepareSeconds: 0,
        openSeconds: 0,
        closeSeconds: 0,
        rankingSeconds: 0,
        publishTime: new Date(),
        unpublishTime: null,
        thumbnail: null,
        thumbnailFile: null
    });

    const validations = {
        name: { required },
        prepareSeconds: { required, integer, min: minValue(1) },
        openSeconds: { required, integer, min: minValue(1) },
        closeSeconds: { required, integer, min: minValue(1) },
        rankingSeconds: { required, integer, min: minValue(0) },
        unpublishTime: {}
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: () => duplicateService.item.get(model.id),
        onSuccess: ({ data }) => {
            data.publishTime = new Date(data.publishTime);
            data.unpublishTime = data.unpublishTime ? new Date(data.unpublishTime) : null;
            Object.assign(model, data);
        },
        onError: () => router.push({ name: ROUTE_NAME_DUPLICATE.ITEM.INDEX })
    });

    const actions = {
        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () =>
                duplicateService.item.update(
                    model.id,
                    model.name,
                    model.prepareSeconds,
                    model.openSeconds,
                    model.closeSeconds,
                    model.rankingSeconds,
                    model?.unpublishTime?.getTime() ?? null,
                    model.thumbnailFile
                ),
            onSuccess: () => router.push({ name: ROUTE_NAME_DUPLICATE.ITEM.INDEX })
        })
    };

    onMounted(async () => {
        await fetchAllMatches();
        await fetch();
    });

    return { model, v$, fetch, gameMatchOptions, actions, timeUnits };
}
